import type { TRuleWithTheme } from '@/styles/theme';

// The shared secret text sizes every mask like a password (1.125rem). A connection URL is long, so its
// mask reads at the same size as the revealed URL. Scoped here — SSH keys and secure notes share that rule.
export const connectionUrlMask: TRuleWithTheme = ({ theme }) => ({
    fontSize: theme.typography.ParagraphNormalRegular.fontSize,
});
